import React from "react";
import { Link } from "react-router-dom";

/* Un lien de l'application. Vers une page du site (« /reglement », « /inscription ») on
   reste DANS l'application : changement d'écran instantané, sans recharger la page — un
   rechargement complet laissait parfois un écran blanc dans l'app installée sur iPhone.
   Vers l'extérieur (Google, e-mail, téléphone), un lien ordinaire. */
/* Seuls les liens sûrs sont suivis : une page de l'app (« /… »), http(s), e-mail ou
   téléphone. Un `javascript:` ou `data:` glissé dans une annonce n'est jamais rendu
   cliquable (défense en profondeur : la console le refuse déjà). */
const lienSur = (href) => {
  const h = String(href || "").trim();
  if (h.startsWith("/")) return !h.startsWith("//") && !h.includes("\\");
  return /^(https?:\/\/|mailto:|tel:)/i.test(h);
};

/* Une page du site ouverte DEPUIS l'application (cours privé, billet, essai, bénévolat,
   workshop…) porte `app=1` : elle affiche alors en haut « ← Retour à l'app »
   (components/RetourApp.jsx) — l'app installée n'a pas de bouton « retour » du navigateur
   (Jen, 01.11.2026). Une adresse complète du même site devient un chemin
   (« /mon-cours-prive?… ») : on reste dans l'application, sans recharger. Une adresse d'un
   autre site est rendue telle quelle. */
export const versPageDuSite = (href) => {
  if (!lienSur(href)) return href;
  try {
    const u = new URL(String(href).trim(), window.location.origin);
    if (u.origin !== window.location.origin) return href;
    u.searchParams.set("app", "1");
    return `${u.pathname}${u.search}${u.hash}`;
  } catch {
    return href;
  }
};

export const Lien = ({ href, children, ...props }) => {
  if (!lienSur(href)) {
    return <span {...props}>{children}</span>;
  }
  href = String(href).trim();
  if (href.startsWith("/") && !href.startsWith("//")) {
    return <Link to={href} {...props}>{children}</Link>;
  }
  const externe = /^https?:/i.test(href);
  return (
    <a href={href} target={externe ? "_blank" : undefined}
      rel={externe ? "noopener noreferrer" : undefined} {...props}>{children}</a>
  );
};
